import { Box } from "@mui/material";
import DashboardSidebar from "./DashboardSidebar";
import DashboardNavbar from "./DashboardNavbar";

const DashboardLayout = ({ children }) => {
  return (
    <div className="app">
      <DashboardSidebar />
      <main className="content">
        <DashboardNavbar />
        <Box m="20px">{children}</Box>
      </main>
    </div>
  );
};

export default DashboardLayout;
